export default {
  // ------共用------
  Shared: {
    Prompt: '提示',
    requestLoadFailed: '加载失败，请稍后重试！',
    requestErrorCode: '错误码：{code}',
    requestTraceId: '追踪编号：',
    Cancel: '取消',
    Confirm: '确定',
    Close: '关闭',
    Save: '保存',
    Submit: '提交',
    Return: '返回',
    del: '删除',
    Remove: '移除',
    Reset: '重置',
    Query: '查询',
    Filter: '筛选',
    success: '操作成功',
    editMessage: '修改成功',
    pleaseEnter: '请输入',
    pleaseChoose: '请选择',
    Male: '男',
    Female: '女',
    Unknown: '未知',
    Operation: '操作',
    NextStep: '下一步',
    PreStep: '上一步',
    Clear: '清空',
    Selected: '已选择',
    Select: '已选',
    Disabled: '禁用',
    Enable: '启用',
    edit: '编辑',
    status: '状态',
    Creator: '创建人',
    UpdatedBy: '更新人',
    Operator: '操作人',
    CreationTime: '创建时间',
    periodValidity: '有效期',
    Loading: '加载中...',
    loaded: '已加载全部数据',
    BatchOperation: '批量操作',
    maxSelected: '最多选择',
    Insert: '插入',
    Sort: '排序',
    CancelSelect: '取消选择',
    Unlimited: '无限制',
    isLimited: '限制',
    info: '刷新',
  },
  editorToolbar: {
    undo: '撤销',
    redo: '重做',
    bold: '加粗',
    italic: '斜体',
    underline: '下划线',
    strike: '删除线',
    blockquote: '引用',
    codeBlock: '代码块',
    orderedList: '有序列表',
    bulletList: '无序列表',
    decreaseIndent: '减少缩进',
    increaseIndent: '增加缩进',
    fontSize: '字体大小',
    heading: '标题格式',
    textColor: '文字颜色',
    backgroundColor: '背景颜色',
    alignment: '对齐方式',
    clearFormat: '清除格式',
    link: '插入链接',
    image: '插入图片',
    video: '插入视频',
  },
  form: {
    StartDate: '开始日期',
    EndDate: '结束日期',
  },
  State: {
    Business: '营业',
    Busy: '繁忙',
    Rest: '休息',
    ClosedDay: '全天打烊',
    BusinessDay: '全天营业',
  },
  Unit: {
    zhang: '张',
    millisecond: '毫秒',
    data: '条数据',
    everyWeek: '每周',
    day: '天',
    person: '人',
    time: '次',
    yuan: '元',
    off: '是',
    on: '否',
    offSale: '可售',
    onSale: '停售',
    HOUR: '小时',
    DAY: '天',
    WEEK: '周',
    MONTH: '月',
    YEAR: '年',
  },
  exchange: {
    LOTTERY: '彩票',
    INTEGRAL: '积分',
    COIN: '代币',
    GIFT_COIN: '赠币',
  },

  // 路由国际化
  route: {
    dashboard: '首页',
    document: '项目文档',
  },
  // 登录页面国际化
  login: {
    selectPlaceholder: '请选择/输入公司名称',
    welcome: '欢迎使用智界',
    account: '账号',
    username: '用户名',
    password: '密码',
    showPassword: '显示',
    hidePassword: '隐藏',
    phoneNumber: '手机号',
    smsCode: '短信验证码',
    login: '登录',
    logging: '登录中...',
    code: '验证码',
    passwordLogin: '密码登录',
    phoneLogin: '手机号登录',
    rememberAccount: '记住账号',
    rememberPassword: '记住我',
    forgotPassword: '忘记密码？',
    sendCode: '获取验证码',
    resendAfter: '{seconds} 秒后重发',
    smsSent: '验证码已发送',
    agreementPrefix: '我已阅读并同意',
    serviceAgreement: '《智趣服务条款》',
    agreementAnd: '和',
    privacyPolicy: '《智趣隐私政策》',
    collectionList: '智趣个人信息收集清单',
    backToLogin: '返回登录',
    chinese: '中文',
    english: 'English',
    agreementRequired: '请先阅读并同意服务协议和隐私政策',
    agreementConfirmTitle: '服务协议与隐私政策',
    agreementConfirmPrefix: '请阅读并同意',
    agreementConfirmSuffix: '后继续登录。',
    agreementConfirmMessage: '请阅读并同意服务协议和隐私政策后继续登录。',
    agreeAndLogin: '勾选并登录',
    contactAdmin: '请联系管理员获取相关信息',
    downloadApp: '下载智界灵动版APP',
    switchRegisterPage: '立即注册',
    title: '您好，欢迎登录！',
    logoutTitle: '确定注销并退出系统吗？',
    accountLogin: '账号登录',
    qrCodeLogin: '扫码登录',
    qrLoginTitle: '扫码登录',
    qrCodeTip: '请使用智界灵动版APP扫码登录',
    qrValidFor: '二维码有效期：{seconds}s',
    qrCodePosterAlt: '电玩城活动海报',
    qrCodeAlt: '登录二维码',
    scanScanned: '已扫码',
    scanConfirmTip: '请在智界灵动版APP确认登录',
    scanRefresh: '刷新二维码',
    scanCreating: '二维码加载中...',
    scanLoadFailed: '二维码加载失败',
    scanExpired: '二维码已过期',
    scanCancelled: '扫码登录已取消',

    rule: {
      tenantId: {
        required: '请输入您的租户编号',
      },
      username: {
        required: '请输入您的账号',
      },
      password: {
        required: '请输入您的密码',
        length: '密码长度必须在{min}~{max}个字符之间',
      },
      phoneNumber: {
        required: '请输入您的手机号',
      },
      code: {
        required: '请输入验证码',
      },
    },
    social: {
      wechat: '微信登录',
      maxkey: 'MaxKey登录',
      topiam: 'TopIam登录',
      gitee: 'Gitee登录',
      github: 'Github登录',
    },
  },
  // 注册页面国际化
  register: {
    selectPlaceholder: '请选择/输入公司名称',
    username: '用户名',
    password: '密码',
    confirmPassword: '确认密码',
    register: '注 册',
    registering: '注 册 中...',
    registerSuccess: '恭喜你，您的账号 {username} 注册成功！',
    code: '验证码',
    switchLoginPage: '使用已有账户登录',
    rule: {
      tenantId: {
        required: '请输入您的租户编号',
      },
      username: {
        required: '请输入您的账号',
        length: '用户账号长度必须介于 {min} 和 {max} 之间',
      },
      password: {
        required: '请输入您的密码',
        length: '用户密码长度必须介于 {min} 和 {max} 之间',
        pattern: '不能包含非法字符：{strings}',
      },
      code: {
        required: '请输入验证码',
      },
      confirmPassword: {
        required: '请再次输入您的密码',
        equalToPassword: '两次输入的密码不一致',
      },
    },
  },

  // 导航栏国际化
  navbar: {
    full: '全屏',
    expor: '下载中心',
    muneout: '收起导航',
    munesut: '展开导航',
    language: '语言',
    dashboard: '首页',
    document: '项目文档',
    message: '通知',
    layoutSize: '布局大小',
    selectTenant: '选择租户',
    layoutSetting: '布局设置',
    version: '版本',
    updata: '更新',
    admin: '账号',
    personalCenter: '个人中心',
    logout: '退出登录',
    SwitchStores: '切换门店',
  },
  // 下载组件提示
  expor: {
    applyTime: '申请时间',
    applyName: '申请人',
    remark: '备注',
    remarkPla: '请输入备注！',
    status1: '数据准备完成',
    status2: '数据准备中,请稍等',
    status3: '数据导出失败',
    search: '请输入文件名称搜索',
    title1: '导出百万级数据等待实际较长（平均等待1小时），建议次日查询',
    title2: '下载中心仅保留一周内的准备数据，请及时下载所需数据',
    export: '导出',
    exportName: '名称',
    exporttip: '请选择导出内容',
    exportSuccess: '导出成功，请前往导出中心查看！',
    exportNameTip: '【在右上角>下载中心】查看导出任务进度',
  },
  excel: {
    fail: '校验失败',
    success: '校验成功',
    sFail: '部分校验失败',
    failDetail: '查看错误详情',
    tip: '失败数据在Excel中修改后重新导入',
    successtip: '点击 导入 可录入系统',
    Import: '导入',
    failImport: '忽略错误继续导入',
    typew: '仅允许导入xls、xlsx格式文件',
    cilckPush: '点击上传',
    cilckPushTip: '将文件拖到此处，或',
    importTemplate: '下载模版',
    ischeTip: '已选字段',
    chetip: '可选字段',
  },

  // 个人中心
  PersonalCenter: {
    ChangePassword: '修改密码',
    PersonalInformation: '个人信息',
    BasicInformation: '基础资料',
    Username: '用户名称',
    Phone: '手机号码',
    Email: '用户邮箱',
    Department: '所属部门',
    AffiliatedRole: '所属角色',
    CreationDate: '创建日期',
    OldPassword: '旧密码',
    NewPassword: '新密码',
    Gender: '性别',
    ConfirmPassword: '确认密码',
    message_1: '两次输入的密码不一致',
    message_2: '旧密码不能为空',
    message_3: '新密码不能为空',
    message_4: '用户昵称不能为空',
    message_5: '不能包含非法字符：< > " \' \\ |',
    message_6: '确认密码不能为空',
  },
};
